"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _contentRegions = _interopRequireDefault(require("../constants/contentRegions"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DUPLICATE_NAME_ERROR = 'An organisation already exists with this name.';
var DUPLICATE_ALIAS_ERROR = 'This alias is already taken. Try another.';

function BasicProfileForm(_ref) {
  var validForm = _ref.validForm,
      name = _ref.name,
      alias = _ref.alias,
      socialProfiles = _ref.socialProfiles,
      imageUrl = _ref.imageUrl,
      organisations = _ref.organisations,
      industry = _ref.industry,
      contentRegion = _ref.contentRegion,
      location = _ref.location,
      notes = _ref.notes,
      parentOrganisation = _ref.parentOrganisation,
      industries = _ref.industries,
      onSelectImage = _ref.onSelectImage,
      updateInputField = _ref.updateInputField,
      updateAliasField = _ref.updateAliasField,
      updateLocation = _ref.updateLocation,
      isValidOrganisationField = _ref.isValidOrganisationField,
      isAliasTaken = _ref.isAliasTaken,
      saving = _ref.saving,
      onSave = _ref.onSave,
      hasUpdatePermission = _ref.hasUpdatePermission;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_uiKit.Input, {
    id: "name-input",
    className: "organisation-basic-profile__name",
    defaultValue: name,
    onChange: updateInputField('name'),
    placeholder: "Enter client name",
    validate: isValidOrganisationField('name'),
    errorMessage: DUPLICATE_NAME_ERROR,
    disabled: !hasUpdatePermission
  }), _react.default.createElement("div", {
    className: "organisation-basic-profile__alias-container"
  }, _react.default.createElement(_uiKit.Text, {
    className: "organisation-basic-profile__alias-container__title"
  }, "Unique Alias"), _react.default.createElement("div", {
    className: "organisation-basic-profile__alias"
  }, _react.default.createElement("input", {
    id: "alias-input",
    value: alias,
    onChange: updateAliasField,
    placeholder: "clientname",
    disabled: !hasUpdatePermission
  }), _react.default.createElement(_uiKit.Text, null, ".".concat(window.location.host)))), !isAliasTaken && _react.default.createElement(_uiKit.Text, {
    className: "organisation-basic-profile__alias-error"
  }, DUPLICATE_ALIAS_ERROR), _react.default.createElement("hr", null), _react.default.createElement(_commonReact.SocialProfiles, {
    className: "organisation-basic-profile__details",
    title: "Client Details",
    socialProfiles: socialProfiles,
    onSave: updateInputField('socialProfiles'),
    onSelectImage: onSelectImage,
    profileImage: imageUrl,
    modalDescription: "",
    disabled: !hasUpdatePermission
  }), _react.default.createElement(_uiKit.Input, {
    id: "parent-company-input",
    placeholder: "Enter parent company",
    prefix: "company",
    onChange: updateInputField('parentOrganisation'),
    allSuggestions: organisations,
    defaultValue: parentOrganisation,
    label: "Parent Company",
    disabled: !hasUpdatePermission
  }), _react.default.createElement(_uiKit.Input, {
    id: "industry-input",
    placeholder: "Enter industry",
    label: "Industry*",
    allSuggestions: industries,
    defaultValue: industry,
    onChange: updateInputField('industry'),
    disabled: !hasUpdatePermission
  }), _react.default.createElement(_uiKit.Dropdown, {
    id: "content-region-input",
    options: _contentRegions.default,
    onChange: updateInputField('contentRegion'),
    defaultValue: contentRegion,
    label: "Content Region*",
    disabled: !hasUpdatePermission
  }), _react.default.createElement("div", {
    className: "organisation-basic-profile__location-selector"
  }, _react.default.createElement(_uiKit.LocationSelector, {
    id: "select-location",
    label: "Location*",
    onSelectAddress: updateLocation,
    initialAddress: location,
    disabled: !hasUpdatePermission
  })), _react.default.createElement(_uiKit.Input, {
    className: "organisation-basic-profile__notes",
    id: "notes-input",
    label: "Additional Notes",
    multiline: true,
    onChange: updateInputField('notes'),
    placeholder: "Enter notes",
    defaultValue: notes,
    disabled: !hasUpdatePermission
  }), _react.default.createElement(_uiKit.Button, {
    id: "submit-button",
    busy: saving,
    onClick: onSave,
    disabled: !validForm
  }, hasUpdatePermission ? 'Save & Continue' : 'Continue'));
}

var _default = BasicProfileForm;
exports.default = _default;